import { Box } from "@mui/material";
import MetricCard from "../../App/Components/MetricCard/MetricCard";
import { EmailPerformanceReportState } from "./EmailPerformanceReportState";
import { useFlags } from "launchdarkly-react-client-sdk";
import { IFeatureToggles } from "../../App/Typings/FeatureToggles";

export default function EmailMetricCards({ id, state }: { id: string; state: EmailPerformanceReportState }) {
  const {
    getters: {
      reportData,
      isLoadingPrevReport,
      prevDeliveredCount,
      prevOpenCount,
      prevClickCount,
      prevStartDate,
      prevEndDate,
      prevUnsubscribeCount,
      deliveredPercentChange,
      openPercentChange,
      clickPercentChange,
      unsubscribePercentChange,
    },
  } = state;

  const { enableEmailsDeliveredAnalytics } = useFlags<IFeatureToggles>();

  const emailsDelivered =
    (reportData?.dataPoints ?? []).reduce((acc, curr) => acc + curr.deliveredCount, 0) || 0;
  const emailOpens = (reportData?.dataPoints ?? []).reduce((acc, curr) => acc + curr.openCount, 0) || 0;
  const emailClicks = (reportData?.dataPoints ?? []).reduce((acc, curr) => acc + curr.clickCount, 0) || 0;
  const emailUnsubscribes =
    (reportData?.dataPoints ?? []).reduce((acc, curr) => acc + curr.unsubscribeCount, 0) || 0;
  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 1, md: 2 },
        justifyContent: "stretch",
        ".MuiCard-root": {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          flexBasis: { xs: "100%", sm: "calc(50% - 1rem)", md: "calc(25% - 1rem)" },
          p: 1,
        },
        ".MuiCardContent-root": {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          p: 1,
          "&:last-child": { pb: 1 },
        },
        ".MuiTypography-root": { p: 0, m: 0 },
        ".MuiTypography-h4": { display: "flex", alignItems: "center", justifyContent: "space-between" },
      }}
    >
      {enableEmailsDeliveredAnalytics && (
        <MetricCard
          id={`${id}-emails-delivered`}
          title="Emails Delivered"
          data={emailsDelivered}
          prevData={prevDeliveredCount}
          percentChange={deliveredPercentChange}
          prevStartDate={prevStartDate}
          prevEndDate={prevEndDate}
          isLoadingPrevReport={isLoadingPrevReport}
        />
      )}
      <MetricCard
        id={`${id}-email-opens`}
        title="Email Unique Opens"
        data={emailOpens}
        prevData={prevOpenCount}
        percentChange={openPercentChange}
        prevStartDate={prevStartDate}
        prevEndDate={prevEndDate}
        isLoadingPrevReport={isLoadingPrevReport}
      />
      <MetricCard
        id={`${id}-email-clicks`}
        title="Email Clicks"
        data={emailClicks}
        prevData={prevClickCount}
        percentChange={clickPercentChange}
        prevStartDate={prevStartDate}
        prevEndDate={prevEndDate}
        isLoadingPrevReport={isLoadingPrevReport}
      />
      <MetricCard
        id={`${id}-email-unsubscribes`}
        title="Email Unsubscribes"
        data={emailUnsubscribes}
        prevData={prevUnsubscribeCount}
        percentChange={unsubscribePercentChange}
        prevStartDate={prevStartDate}
        prevEndDate={prevEndDate}
        isLoadingPrevReport={isLoadingPrevReport}
        reverse
      />
    </Box>
  );
}
